import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalIssueNavigatorBrowseIssueRedirectRoute: InvariantJiraRoute = {
	name: 'global-issue-navigator-browse-issue-redirect',
	path: '/browse/:issueKey?',
	query: ['jql|filter'],
};
